import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Table,
  Badge,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Progress,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import CommonHeader from "components/Headers/CommonHeader.js";
import CustomDropdown from "components/Common/CustomDropdown";
import CustomPagination from "components/Common/CustomPagination";
import LoadingDots from "components/Common/LoadingDots";
import Swal from "sweetalert2";
import {
  FaShieldAlt,
  FaCheckCircle,
  FaTimesCircle,
  FaUserCheck,
  FaIdCard,
  FaCamera,
  FaSearch,
  FaEye,
  FaAward,
  FaMapMarkerAlt,
  FaExclamationTriangle,
  FaMedkit,
  FaPassport,
} from "react-icons/fa";

const ITEMS_PER_PAGE = 7;

const DUMMY_SAFETY_DATA = [
  {
    id: "VERIF-8901",
    guide: {
      name: "Marcus Vance",
      email: "marcus.vance@localmate.com",
      phone: "+44 7911 123456",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&auto=format&fit=crop&q=60",
      city: "London",
      country: "United Kingdom",
      age: 29,
    },
    docType: "Passport",
    docFront: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=400&auto=format&fit=crop&q=60",
    selfieImage: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&auto=format&fit=crop&q=60",
    facialMatchScore: 98.6,
    phoneVerified: true,
    emailVerified: true,
    backgroundCheckStatus: "passed", // passed, pending, failed
    firstAidCertified: true,
    tourismCertified: true,
    badgeLevel: "Verified Pro Badge", // Verified Guide Badge, Verified Pro Badge, None
    verificationStatus: "approved", // approved, pending, rejected
    liveGpsStatus: "Safe & Active (Tour #BK-4920 in Soho)",
    submittedAt: "2026-09-01",
  },
  {
    id: "VERIF-8902",
    guide: {
      name: "Elena Rostova",
      email: "elena.rostova@localmate.com",
      phone: "+39 06 698745",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&auto=format&fit=crop&q=60",
      city: "Rome",
      country: "Italy",
      age: 31,
    },
    docType: "Driver's License",
    docFront: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=400&auto=format&fit=crop&q=60",
    selfieImage: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&auto=format&fit=crop&q=60",
    facialMatchScore: 97.2,
    phoneVerified: true,
    emailVerified: true,
    backgroundCheckStatus: "passed",
    firstAidCertified: true,
    tourismCertified: false,
    badgeLevel: "Verified Guide Badge",
    verificationStatus: "approved",
    liveGpsStatus: "Standby (Available in Trastevere)",
    submittedAt: "2026-09-02",
  },
  {
    id: "VERIF-8903",
    guide: {
      name: "Jean Dupont",
      email: "jean.dupont@localmate.com",
      phone: "+33 6 12345678",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&auto=format&fit=crop&q=60",
      city: "Paris",
      country: "France",
      age: 26,
    },
    docType: "National ID / Passport",
    docFront: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=400&auto=format&fit=crop&q=60",
    selfieImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&auto=format&fit=crop&q=60",
    facialMatchScore: 94.8,
    phoneVerified: true,
    emailVerified: true,
    backgroundCheckStatus: "pending",
    firstAidCertified: false,
    tourismCertified: true,
    badgeLevel: "None",
    verificationStatus: "pending",
    liveGpsStatus: "Offline",
    submittedAt: "2026-09-03",
  },
  {
    id: "VERIF-8904",
    guide: {
      name: "Chloe Dubois",
      email: "chloe.d@localmate.com",
      phone: "+33 6 87654321",
      avatar: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&auto=format&fit=crop&q=60",
      city: "Lyon",
      country: "France",
      age: 24,
    },
    docType: "Driver's License",
    docFront: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=400&auto=format&fit=crop&q=60",
    selfieImage: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&auto=format&fit=crop&q=60",
    facialMatchScore: 99.1,
    phoneVerified: true,
    emailVerified: true,
    backgroundCheckStatus: "passed",
    firstAidCertified: true,
    tourismCertified: true,
    badgeLevel: "Verified Pro Badge",
    verificationStatus: "approved",
    liveGpsStatus: "Safe & Active (Old Lyon Walk)",
    submittedAt: "2026-08-28",
  },
  {
    id: "VERIF-8905",
    guide: {
      name: "Kenji Sato",
      email: "kenji.sato@localmate.com",
      phone: "+81 90 1234 5678",
      avatar: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&auto=format&fit=crop&q=60",
      city: "Tokyo",
      country: "Japan",
      age: 33,
    },
    docType: "Driver's License & Vehicle Registration",
    docFront: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=400&auto=format&fit=crop&q=60",
    selfieImage: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&auto=format&fit=crop&q=60",
    facialMatchScore: 98.9,
    phoneVerified: true,
    emailVerified: true,
    backgroundCheckStatus: "passed",
    firstAidCertified: true,
    tourismCertified: true,
    badgeLevel: "Verified Pro Badge",
    verificationStatus: "approved",
    liveGpsStatus: "Active (Shibuya Food Tour)",
    submittedAt: "2026-08-20",
  },
  {
    id: "VERIF-8906",
    guide: {
      name: "Arthur Pendelton",
      email: "arthur.p@example.com",
      phone: "+1 214 555 0199",
      avatar: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=100&auto=format&fit=crop&q=60",
      city: "Dallas",
      country: "United States",
      age: 22,
    },
    docType: "Driver's License",
    docFront: "https://images.unsplash.com/photo-1544717305-2782549b5136?w=400&auto=format&fit=crop&q=60",
    selfieImage: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&auto=format&fit=crop&q=60",
    facialMatchScore: 68.2, // low score -> flagged
    phoneVerified: true,
    emailVerified: false,
    backgroundCheckStatus: "failed",
    firstAidCertified: false,
    tourismCertified: false,
    badgeLevel: "None",
    verificationStatus: "rejected",
    liveGpsStatus: "Blocked",
    submittedAt: "2026-09-02",
  },
];

const SafetyVerification = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [activeTab, setActiveTab] = useState("verifications"); // verifications, gps, sos
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setData(DUMMY_SAFETY_DATA);
      setLoading(false);
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  const filteredData = data.filter((item) => {
    const matchesSearch =
      item.guide.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.guide.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.guide.email.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      statusFilter === "all" ? true : item.verificationStatus.toLowerCase() === statusFilter.toLowerCase();

    return matchesSearch && matchesStatus;
  });

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE) || 1;
  const paginatedData = filteredData.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleApprove = (id, badge = "Verified Guide Badge") => {
    Swal.fire({
      title: "Approve Guide Verification?",
      text: `Guide will be awarded the ${badge} and allowed to accept bookings.`,
      icon: "success",
      showCancelButton: true,
      confirmButtonColor: "#2dce89",
      confirmButtonText: `Approve & Award ${badge}`,
    }).then((res) => {
      if (res.isConfirmed) {
        setData((prev) =>
          prev.map((item) =>
            item.id === id
              ? { ...item, verificationStatus: "approved", badgeLevel: badge }
              : item
          )
        );
        setModalOpen(false);
        Swal.fire("Approved!", `Guide verified with ${badge}.`, "success");
      }
    });
  };

  const handleReject = (id) => {
    Swal.fire({
      title: "Reject Verification?",
      input: "textarea",
      inputPlaceholder: "Enter reason for rejection (e.g., blurry ID, selfie mismatch)...",
      showCancelButton: true,
      confirmButtonColor: "#f5365c",
      confirmButtonText: "Reject",
    }).then((res) => {
      if (res.isConfirmed) {
        setData((prev) =>
          prev.map((item) =>
            item.id === id
              ? { ...item, verificationStatus: "rejected", badgeLevel: "None" }
              : item
          )
        );
        setModalOpen(false);
        Swal.fire("Rejected", "Guide verification rejected with explanation sent.", "info");
      }
    });
  };

  return (
    <>
      <CommonHeader />
      <Container className="mt--7" fluid>
        {/* Metric Cards */}
        <Row className="mb-4">
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setStatusFilter("approved");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  statusFilter === "approved"
                    ? "2px solid #2dce89"
                    : "1px solid transparent",
                transform:
                  statusFilter === "approved" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Verified Guides
                    </h5>
                    <span className="h2 font-weight-bold mb-0">842</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                      <FaUserCheck />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-success mr-2 font-weight-bold">96.8%</span>
                  <span>Safety compliance</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setStatusFilter("pending");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  statusFilter === "pending"
                    ? "2px solid #fb6340"
                    : "1px solid transparent",
                transform:
                  statusFilter === "pending" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Pending Reviews
                    </h5>
                    <span className="h2 font-weight-bold mb-0">28</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                      <FaIdCard />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-warning mr-2 font-weight-bold">Avg 2.4 hrs</span>
                  <span>Review turnaround</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card className="card-stats mb-4 mb-xl-0 shadow-sm border-0">
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      Active GPS Trips
                    </h5>
                    <span className="h2 font-weight-bold mb-0">14</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                      <FaMapMarkerAlt />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-info mr-2 font-weight-bold">100% Live</span>
                  <span>Family sharing active</span>
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col lg="3" md="6">
            <Card
              className="card-stats mb-4 mb-xl-0 shadow-sm border-0"
              role="button"
              tabIndex={0}
              onClick={() => {
                setStatusFilter("all");
                setCurrentPage(1);
              }}
              style={{
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border:
                  statusFilter === "all"
                    ? "2px solid #5e72e4"
                    : "1px solid transparent",
                transform:
                  statusFilter === "all" ? "translateY(-3px)" : "none",
              }}
            >
              <CardBody>
                <Row>
                  <div className="col">
                    <h5 className="text-uppercase text-muted mb-0 font-weight-bold">
                      All Records
                    </h5>
                    <span className="h2 font-weight-bold mb-0">All</span>
                  </div>
                  <Col className="col-auto">
                    <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                      <FaShieldAlt />
                    </div>
                  </Col>
                </Row>
                <p className="mt-3 mb-0 text-muted text-sm">
                  <span className="text-primary mr-2 font-weight-bold">Reset</span>
                  <span>Show all guides</span>
                </p>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Main Table Card */}
        <Row>
          <div className="col">
            <Card className="shadow border-0">
              <CardHeader className="border-0 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div>
                  <h3 className="mb-0 text-primary-new font-weight-bold">
                    Guide Safety & Verification Center
                  </h3>
                  <small className="text-muted">
                    Manage live selfie verification, ID checks, facial match scores, background checks & safety badges
                  </small>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-2 mt-3 mt-md-0">
                  <InputGroup className="input-group-alternative" style={{ width: "260px" }}>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <FaSearch className="text-muted" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search guide name, city, ID..."
                      type="text"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </InputGroup>

                  <Input
                    type="select"
                    style={{ width: "160px" }}
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                    className="custom-select"
                  >
                    <option value="all">All Status</option>
                    <option value="approved">Approved</option>
                    <option value="pending">Pending</option>
                    <option value="rejected">Rejected</option>
                  </Input>
                </div>
              </CardHeader>

              {loading ? (
                <div className="py-5 text-center">
                  <LoadingDots message="Loading safety & verification records..." />
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive hover>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Record ID</th>
                      <th scope="col">Local Guide</th>
                      <th scope="col">City & Location</th>
                      <th scope="col">Document Type</th>
                      <th scope="col">Facial Match</th>
                      <th scope="col">Certifications & Checks</th>
                      <th scope="col">Badge Awarded</th>
                      <th scope="col">Status</th>
                      <th scope="col" className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length > 0 ? (
                      paginatedData.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <span className="font-weight-bold text-primary">{item.id}</span>
                            <div className="small text-muted">{item.submittedAt}</div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                src={item.guide.avatar}
                                alt={item.guide.name}
                                className="avatar avatar-sm rounded-circle mr-2"
                              />
                              <div>
                                <span className="mb-0 text-sm font-weight-bold d-block">
                                  {item.guide.name}
                                </span>
                                <small className="text-muted">{item.guide.phone}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="font-weight-bold text-dark">{item.guide.city}</span>
                            <div className="small text-muted">{item.guide.country}</div>
                          </td>
                          <td>
                            <span className="text-sm font-weight-500">{item.docType}</span>
                            <div className="small text-muted d-flex align-items-center">
                              <FaCamera className="mr-1 text-primary" /> Live Selfie Verified
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <span className="mr-2 font-weight-bold text-dark">
                                {item.facialMatchScore}%
                              </span>
                              <div>
                                <Progress
                                  max="100"
                                  value={item.facialMatchScore}
                                  color={
                                    item.facialMatchScore >= 95
                                      ? "success"
                                      : item.facialMatchScore >= 80
                                      ? "warning"
                                      : "danger"
                                  }
                                  style={{ height: "6px", width: "70px" }}
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex flex-column gap-1">
                              <div>
                                <Badge
                                  color={item.backgroundCheckStatus === "passed" ? "success" : item.backgroundCheckStatus === "pending" ? "warning" : "danger"}
                                  pill
                                  className="mr-1"
                                >
                                  BG Check: {item.backgroundCheckStatus}
                                </Badge>
                              </div>
                              <div className="mt-1">
                                {item.firstAidCertified && (
                                  <Badge color="info" pill className="mr-1">
                                    <FaMedkit className="mr-1" /> First Aid
                                  </Badge>
                                )}
                                {item.tourismCertified && (
                                  <Badge color="primary" pill>
                                    <FaAward className="mr-1" /> Tourism Cert
                                  </Badge>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            {item.badgeLevel === "Verified Pro Badge" && (
                              <Badge color="warning" className="p-2">
                                <FaAward className="mr-1" /> Verified Pro
                              </Badge>
                            )}
                            {item.badgeLevel === "Verified Guide Badge" && (
                              <Badge color="success" className="p-2">
                                <FaCheckCircle className="mr-1" /> Verified Guide
                              </Badge>
                            )}
                            {item.badgeLevel === "None" && (
                              <Badge color="light" className="p-2 text-muted">
                                Not Awarded
                              </Badge>
                            )}
                          </td>
                          <td>
                            {item.verificationStatus === "approved" && (
                              <Badge color="success" className="badge-dot mr-4">
                                <i className="bg-success" /> Approved
                              </Badge>
                            )}
                            {item.verificationStatus === "pending" && (
                              <Badge color="warning" className="badge-dot mr-4">
                                <i className="bg-warning" /> Pending Review
                              </Badge>
                            )}
                            {item.verificationStatus === "rejected" && (
                              <Badge color="danger" className="badge-dot mr-4">
                                <i className="bg-danger" /> Rejected
                              </Badge>
                            )}
                          </td>
                          <td className="text-right">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem
                                  onClick={() => {
                                    setSelectedRecord(item);
                                    setModalOpen(true);
                                  }}
                                >
                                  <FaEye className="mr-2 text-primary" /> Inspect Identity & Docs
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() => handleApprove(item.id, "Verified Guide Badge")}
                                >
                                  <FaCheckCircle className="mr-2 text-success" /> Approve (Verified Guide)
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() => handleApprove(item.id, "Verified Pro Badge")}
                                >
                                  <FaAward className="mr-2 text-warning" /> Approve (Verified Pro)
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={() => handleReject(item.id)}>
                                  <FaTimesCircle className="mr-2 text-danger" /> Reject Verification
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center py-4 text-muted">
                          No verification records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}

              {/* Unified Pagination */}
              {!loading && filteredData.length > 0 && (
                <CardFooter className="py-4 border-0">
                  <CustomPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalItems={filteredData.length}
                    itemsPerPage={ITEMS_PER_PAGE}
                    onPageChange={(page) => setCurrentPage(page)}
                    itemName="verifications"
                  />
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>

        {/* Modal for Document & Selfie Inspection */}
        {selectedRecord && (
          <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} size="lg" centered>
            <ModalHeader
              toggle={() => setModalOpen(!modalOpen)}
              className="bg-light border-bottom"
            >
              <span className="font-weight-bold text-dark">
                Identity & Safety Inspection: {selectedRecord.guide.name}
              </span>
            </ModalHeader>
            <ModalBody className="p-4">
              <Row>
                <Col md="6" className="text-center border-right">
                  <h5 className="font-weight-bold text-muted mb-2">Government Issued ID ({selectedRecord.docType})</h5>
                  <img
                    src={selectedRecord.docFront}
                    alt="ID Document"
                    className="img-fluid rounded border shadow-sm"
                    style={{ maxHeight: "220px", objectFit: "cover" }}
                  />
                  <div className="mt-2 text-success font-weight-bold">
                    <FaCheckCircle className="mr-1" /> Authentic Hologram Detected
                  </div>
                </Col>
                <Col md="6" className="text-center">
                  <h5 className="font-weight-bold text-muted mb-2">Live Camera Selfie</h5>
                  <img
                    src={selectedRecord.selfieImage}
                    alt="Live Selfie"
                    className="img-fluid rounded border shadow-sm"
                    style={{ maxHeight: "220px", objectFit: "cover" }}
                  />
                  <div className="mt-2 text-primary font-weight-bold">
                    <FaCamera className="mr-1" /> Liveness Test Passed (Score: {selectedRecord.facialMatchScore}%)
                  </div>
                </Col>
              </Row>

              <hr />

              <h5 className="font-weight-bold text-dark mb-3">Verification Checklist</h5>
              <Row>
                <Col md="6">
                  <ul className="list-unstyled">
                    <li className="mb-2">
                      <FaCheckCircle className="text-success mr-2" />
                      <strong>Phone Number Verified:</strong> {selectedRecord.guide.phone}
                    </li>
                    <li className="mb-2">
                      <FaCheckCircle className="text-success mr-2" />
                      <strong>Email Address Verified:</strong> {selectedRecord.guide.email}
                    </li>
                    <li className="mb-2">
                      <FaCheckCircle className="text-success mr-2" />
                      <strong>Age Verification (18+):</strong> {selectedRecord.guide.age} years old
                    </li>
                  </ul>
                </Col>
                <Col md="6">
                  <ul className="list-unstyled">
                    <li className="mb-2">
                      <FaCheckCircle className="text-success mr-2" />
                      <strong>Criminal Background Check:</strong> Passed (No records found)
                    </li>
                    <li className="mb-2">
                      <FaCheckCircle className={selectedRecord.firstAidCertified ? "text-success mr-2" : "text-muted mr-2"} />
                      <strong>First Aid Certification:</strong> {selectedRecord.firstAidCertified ? "Certified (Red Cross)" : "Not provided"}
                    </li>
                    <li className="mb-2">
                      <FaCheckCircle className={selectedRecord.tourismCertified ? "text-success mr-2" : "text-muted mr-2"} />
                      <strong>Tourism License:</strong> {selectedRecord.tourismCertified ? "Certified Local Guide" : "Standard Local"}
                    </li>
                  </ul>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className="bg-light">
              <Button color="secondary" onClick={() => setModalOpen(false)}>
                Close
              </Button>
              <Button
                color="danger"
                onClick={() => handleReject(selectedRecord.id)}
              >
                Reject Verification
              </Button>
              <Button
                color="success"
                onClick={() => handleApprove(selectedRecord.id, "Verified Guide Badge")}
              >
                Award Verified Guide Badge
              </Button>
              <Button
                color="warning"
                onClick={() => handleApprove(selectedRecord.id, "Verified Pro Badge")}
              >
                Award Verified Pro Badge
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Container>
    </>
  );
};

export default SafetyVerification;
